<template lang='pug'>
div
  div(v-for='(variable, i) in variables', :key='i')
    slide-y-down-transition
      v-row(no-gutters)
        v-col(:cols='!denseWidth ? "3" : "4"')
          md-field(:class='{ "md-invalid md-error": variable.duplicated }')
            md-input.contextInput(
              :disabled='readOnlyKeys || readOnly'
              v-model='variable.name'
              @input='updateVariable(variable, "name", $event)'
              placeholder='Adicione o nome para essa variável')
            .md-error {{$t('objectEditor.duplicateVariable')}}
        v-col(:cols='!denseWidth ? "9" : "8"')
          v-row.mx(no-gutters)
            v-col.mr(:cols='!denseWidth ? "auto" : "3"')
              md-field
                label(v-if='!denseWidth') {{ $t("commonWords.type") }}
                md-select(
                  :disabled='readOnlyValues || readOnly'
                  v-model='variable.type'
                  @input='updateVariableType(variable)')
                  md-option(value='text') {{ $t("commonWords.string") }}
                  md-option(value='boolean') {{ $t("commonWords.boolean") }}
                  md-option(value='number') {{ $t("commonWords.number") }}
            v-col(style='align-self: center')
              md-checkbox(
                v-if='variable.type === "boolean"'
                v-model='variable.value'
                @change='updateVariable(variable, "value", $event)'
                style='margin-left: 24px') {{ variable.value }}
              v-row(v-else no-gutters style='padding: 0')
                v-col(
                  cols='auto'
                  style='align-self: center;',
                  :style='variable.type === "number" ? "padding: 3px 0 0  0" : "padding: 4px 0 0  0;"')
                  v-icon {{ variable.type === "number" ? "mdi-numeric" : "mdi-alphabetical-variant" }}
                v-col(style='padding: 0')
                  md-field
                    md-input.contextInput(
                      :disabled='readOnlyValues || readOnly',
                      :value='variable.value'
                      @input='updateVariable(variable, "value", $event)'
                      :placeholder="$t('objectEditor.addValueToThisVariable')"
                      :type='variable.type')
            v-col(
              cols='auto'
              v-if='!disableRemove(variable)'
              style='align-self: center')
              span(@click='removeVariable(i, variable)')
                md-icon(
                  style='cursor: pointer; color: blue; padding-left: 24px;')
                  | horizontal_rule
    v-divider
  v-row(
    v-if='!disableAdding && !readOnly'
    no-gutters
    style='margin-bottom: 6px; margin-top: 3px;')
    v-col(:cols='!denseWidth ? "3" : "4"')
      md-field(:class='{ "md-invalid md-error": newVariable.duplicated }')
        md-input.contextInput(
          v-model='newVariable.name'
          @input='updateVariable(newVariable, "name", newVariable.name)'
          placeholder='Adicione o nome para essa variável')
        .md-error {{$t('objectEditor.variableAlreadyExists')}}
    v-col(:cols='!denseWidth ? "9" : "8"')
      v-row.mx(no-gutters)
        v-col.mr(:cols='!denseWidth ? "auto" : "3"')
          md-field
            label(v-if='!denseWidth') {{ $t("commonWords.type") }}
            md-select(
              :disabled='newVariable.name == ""'
              v-model='newVariable.type'
              @input='updateVariableType(newVariable)'
              @md-selected='checkIfBooleanType($event)')
              md-option(value='text') {{ $t("commonWords.string") }}
              md-option(value='boolean') {{ $t("commonWords.boolean") }}
              md-option(value='number') {{ $t("commonWords.number") }}
        v-col(style='align-self: center')
          md-checkbox(
            v-if='newVariable.type === "boolean"'
            v-model='newVariable.value'
            style='margin-left: 24px') {{ newVariable.value }}
          v-row(v-else no-gutters style='padding: 0')
            v-col(
              cols='auto'
              style='align-self: center;',
              :style='newVariable.type === "number" ? "padding: 3px 0 0  0" : "padding: 4px 0 0  0;"')
              v-icon {{ newVariable.type === "number" ? "mdi-numeric" : "mdi-alphabetical-variant" }}
            v-col(style='padding: 0')
              md-field
                md-input.contextInput(
                  v-model='newVariable.value'
                  @blur.passive='addVariable()'
                  @keyup.enter.stop='addVariable()'
                  :placeholder="$t('objectEditor.variableAlreadyExists')"
                  :type='newVariable.type')
        v-col(cols='auto' style='align-self: center')
          span(@click='addVariable()')
            md-icon(
              :class='{ "disable-click": newVariable.duplicated }'
              style='cursor: pointer; color: blue; padding-left: 24px;')
              | add
    //- v-col(cols='2' style='align-self: center')
</template>

<script>
import debounce from 'lodash.debounce'
export default {
  name: 'ObjectEditor',
  model: {
    prop: 'object',
    event: 'update'
  },
  props: {
    initialObject: {
      type: Object,
      default: Object
    },
    object: {
      type: Object,
      default: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    readOnlyKeys: {
      type: Boolean,
      default: false
    },
    readOnlyValues: {
      type: Boolean,
      default: false
    },
    disableAdding: {
      type: Boolean,
      default: false
    },
    disableRemovingAllProps: {
      type: Boolean,
      default: false
    },
    disableRemovingInitialProps: {
      type: Boolean,
      default: false
    },
    allowedProps: {
      type: Array,
      default: null
    },
    requiredProps: {
      type: Array,
      default: Array
    },
    denseWidth: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    allowedProps: {
      handler: 'update',
      deep: true
    },
    requiredProps: {
      handler: 'refreshRequiredProps',
      deep: true,
      immediate: true
    }
  },
  data: () => ({
    variables: [],
    newVariable: {
      name: '',
      type: 'text',
      value: ''
    },
    changes: {}
  }),
  methods: {
    initVariables () {
      const typeMapper = {
        boolean: 'boolean',
        string: 'text',
        number: 'number'
      }
      const objectEntries = Object.entries(this.object || {}).filter(
        ([name]) => !this.allowedProps || this.allowedProps.includes(name)
      )
      const missingRequiredEntries = this.requiredProps
        .filter((prop) => !(prop in this.object))
        .map((prop) => [prop, ''])
      const entries = [...missingRequiredEntries, ...objectEntries]
      this.variables = entries.map(([name, value]) => ({
        name,
        value,
        type: typeMapper[typeof value] || 'text'
      }))
      this.variables.forEach(({ name, value }) => {
        if (value && value !== this.initialObject[name]) {
          // console.log(`newChange`, name)
          this.$set(this.changes, name, value)
        }
        this.$emit('value-changes', this.changes)
      })
    },
    update () {
      const object = {}
      this.variables.forEach(({ name, value }) => {
        if (!this.allowedProps || this.allowedProps.includes(name)) {
          object[name] = value
        }
      })
      this.$emit('update', object)
    },
    removeVariable (i, variable) {
      if (this.variables.length === 1) {
        this.variables = []
      } else {
        this.variables.splice(i, 1)
      }
      this.detectValueChanges(variable.name)
      this.update()
    },
    addVariable () {
      if (!this.newVariable.name || this.newVariable.duplicated) return
      this.variables.push(this.newVariable)
      this.detectValueChanges(this.newVariable.name, this.newVariable.value)
      this.newVariable = {
        name: '',
        type: 'text',
        value: ''
      }
      this.update()
    },
    updateVariable: debounce(function (variable, prop, value) {
      if (prop === 'name') {
        variable.duplicated = this.variables.some(
          (v) => v.name === variable.name && v !== variable
        )
        this.newVariable.duplicated = this.variables.some(
          (v) => v.name === this.newVariable.name
        )
      }

      if (prop === 'value') {
        if (variable.type === 'number') {
          variable[prop] = parseFloat(value)
        } else {
          variable[prop] = value
        }
        this.detectValueChanges(variable.name, value)
      }

      if (!variable.duplicated) {
        this.update()
      }
    }, 400),
    detectValueChanges (variableName, newValue) {
      if (
        newValue !== undefined &&
        newValue !== this.initialObject[variableName]
      ) {
        this.$set(this.changes, variableName, newValue)
      } else {
        this.$delete(this.changes, variableName)
      }
      // console.log(`detect value changes`, this.changes)
      this.$emit('value-changes', this.changes)
    },
    updateVariableType (variable) {
      if (variable.type === 'boolean') {
        variable.value = Boolean(variable.value) || false
      } else if (variable.type === 'text') {
        variable.value = variable.value.toString()
      } else if (variable.type === 'number') {
        variable.value = parseFloat(variable.value) || 0
      }
      this.update()
    },
    refreshRequiredProps () {
      this.initVariables()
      // this.update()
    },
    disableRemove (variable) {
      return (
        this.disableRemovingAllProps ||
        this.readOnly ||
        (this.disableRemovingInitialProps &&
          variable.name in this.initialObject)
      )
    },
    checkIfBooleanType (type) {
      // console.log(type)
      if (type === 'boolean') {
        // console.log('entrou')
        this.addVariable()
      }
    }
  },
  mounted () {
    this.initVariables()
  }
}
</script>

<style scoped>
.contextInput {
  background-color: rgb(244, 244, 244) !important;
  padding-left: 4px !important;
}
.disable-click {
  pointer-events: none;
  color: grey !important;
}
.md-invalid.md-error {
  margin-bottom: 20px;
}
.md-error {
  margin-bottom: 5px;
}
.mx {
  margin-left: 10px;
  margin-right: 10px;
}
.ml {
  margin-left: 10px;
}
.mr {
  margin-right: 10px;
}
</style>
